import { Button } from '@morressier/alembic';
import { Flex } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane } from '@fortawesome/pro-regular-svg-icons';

interface MultiStepFooterProps {
  isDisabled: boolean;
  currentStep: number;
  totalSteps: number;
  goToNextStep: () => void;
  inviteReviewers: () => void;
  handleCloseModal: () => void;
  isProcessing: boolean;
  isAttachmentUploading?: boolean;
}

const MultiStepFooter = ({
  isDisabled,
  currentStep,
  totalSteps,
  goToNextStep,
  inviteReviewers,
  handleCloseModal,
  isProcessing,
  isAttachmentUploading
}: MultiStepFooterProps) => {
  return (
    <Flex
      padding={4}
      bottom={0}
      zIndex={99}
      justifyContent="center"
      position="sticky"
      bgColor="surfacePrimaryFill"
    >
      <Flex width="100%" justifyContent="space-between">
        <Button variant="caution" onClick={handleCloseModal}>
          Exit
        </Button>
        <Flex gap={3}>
          {currentStep < totalSteps && (
            <Button
              variant="primary"
              type="button"
              onClick={goToNextStep}
              disabled={isDisabled}
              leftIcon={<FontAwesomeIcon icon={faEnvelope} />}
            >
              Preview and Invite
            </Button>
          )}

          <Button
            variant="primary"
            type="button"
            onClick={inviteReviewers}
            leftIcon={<FontAwesomeIcon icon={faPaperPlane} />}
            disabled={isDisabled || isProcessing || isAttachmentUploading}
            isLoading={isProcessing}
          >
            {currentStep < totalSteps ? 'Invite Now' : 'Invite reviewers'}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MultiStepFooter;
